export default {
  base_url: window.location.origin + "/",
  apiEndPoint: "https://apisetutsa.hmhsistemas.com.mx/"
};
